
<div class="container pt-3">
  <privacy-policy-text></privacy-policy-text>
</div>
